export default "/images/vendor/flag-icon-css/flags/4x3/gy.svg?49a30b4ff82716f3aaddf3e991aef4aa";